//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export OrganizationReportConfig
export const OrganizationReportConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path: "/app/organization/orgReport",
      component: FuseLoadable({
        loader: () => import("./OrganizationReport.js")
      })
    }
  ]
  //end routes
};
